<template lang="html">
  <article id="single-post" class="post">
  <div class="post-content">
    <header class="post-header">
      <h2 class="post-title" itemprop="name headline">
        {{ post.title }}
        <br>
        <small>
          {{post.artist}}
        </small>
      </h2>
      <img :src="`/api/files/${post.image}`" alt="">
    </header>

    <article class="post-content">
      <p>{{post.description}}</p>
      <ul>
        <li>Medium: {{post.medium}} </li>
        <li>Edition: {{post.edition}} </li>
        <li>Dimensions: {{post.width}}x{{ post.height}} </li>
      </ul>
    </article>
  </div>
</article>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "post",
  beforeCreate() {
    const { postId } = this.$route.params
    this.$store.dispatch('getPost', { postId } )
  },
  computed: mapGetters({
    post: 'currentPost'
  })
}
</script>

<style lang="css" scoped>
</style>
